module.exports = __webpack_public_path__ + "img/4305f85.jpg";